import React, { useState } from 'react'

import { ConfirmationModal, Toast } from 'components'

// Utils and Services
import { deleteLeadContact } from 'services/lead-contact'
import { FETCHING_STATUS } from 'utils/constants'
import { useTranslation } from 'react-i18next'

type Props = {
  contactId: string
  onAction: (success?: boolean) => void
}

const DeleteConfirmationModal: React.FC<Props> = ({ contactId, onAction }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { t } = useTranslation()

  const handleDeleteContact = async () => {
    setIsSubmitting(true)

    const response = await deleteLeadContact({ contact_id: contactId })

    setIsSubmitting(false)

    if (response.status === FETCHING_STATUS.fail) {
      // Toast.toastMessage({ actionKey: 'delete', subject: 'lead_contact', variant: 'error' })
      Toast.toastMessage({ variant: 'error', message: response.error?.message })

      return
    }

    Toast.toastMessage({ actionKey: 'delete', subject: 'lead_contact', variant: 'success' })
    onAction(true)
  }

  return (
    <ConfirmationModal
      isSubmitting={isSubmitting}
      cancel={() => onAction(false)}
      submit={handleDeleteContact}
      variant="delete"
      name={t('contact_lbl').toLowerCase()}
    />
  )
}

export default DeleteConfirmationModal
